import NextImage from "next/image";


export const Image = (props: React.ComponentProps<typeof NextImage>) => (
  <div className="media">
    <NextImage {...props} placeholder="blur"></NextImage>
  </div>
);
